import {Component, Input, OnInit} from '@angular/core';
import {ApiService} from "../../services/api.service";

@Component({
  selector: 'app-thank-you',
  templateUrl: './thank-you.component.html',
  styleUrls: ['./thank-you.component.scss']
})
export class ThankYouComponent implements OnInit {

  data

  constructor(
    private api: ApiService
  ) { }

  ngOnInit(): void {
    this.data = this.api.getData();
    console.log(this.data);
  }

}
